<template>
  <div>
    <div class="ccui-navigation" ref="navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
        >返回</el-button
      >
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item :to="{ path: '/' }">{{
          appName
        }}</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/applicationSettings/userManagement' }"
          >应用设置</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/applicationSettings/roleManagement' }"
          >权限管理
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/applicationSettings/roleManagement' }"
          >角色管理
        </el-breadcrumb-item>
        <el-breadcrumb-item
          >成员维护<span class="ccui-curr-crumb" style="margin-left: 10px">
            {{ $route.query.roleName }}</span
          ></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div class="ccui-app-container-detail2 ccui-clearfix">
      <div class="ccui-app-container-detail-body">
        <div
          class="ccui-advanced-search-wrapper ccui-clearfix"
          ref="advancedSearchWrapper"
        >
          <!--普通搜索Begin-->
          <el-search
            :formProp="formData"
            @search="searchItem"
            class="ccui-highsearch"
            :selectClear="true"
          >
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini"
                >全部({{ totalNum }})</el-button
              >
            </div>
            <div class="ccui-extend-btn">
              <el-button
                size="mini"
                type="primary"
                icon="icon-ccui-add-sup"
                @click="handleAddMember"
                class="fright"
                >添加成员
              </el-button>
            </div>
            <template slot="search">
              <el-input
                v-model="formData.name"
                clearable
                searchLabel="姓名"
                placeholder="请输入姓名模糊查询"
              ></el-input>
              <el-select
                v-model="formData.sex"
                clearable
                placeholder="请选择性别模糊查询"
                searchLabel="性别"
              >
                <el-option key="1" label="男" value="1"></el-option>
                <el-option key="2" label="女" value="2"></el-option>
                <el-option key="0" label="未知" value="0"></el-option>
              </el-select>
              <el-select
                clearable
                ref="selectTree1"
                v-model="formData.deptname"
                searchLabel="所在部门"
                placeholder="请选择所在部门查询"
                popper-class="popperTreeSelect"
              >
                <el-option :value="valueUnit" :label="valueUnit">
                  <el-tree
                    :props="defaultProps"
                    :load="loadNode"
                    node-key="id"
                    :default-expanded-keys="[1]"
                    @node-click="handleNodeClick"
                    lazy
                  >
                  </el-tree>
                </el-option>
              </el-select>
              <!--                <el-select-->
              <!--                  v-model="formData.politicalOutlook"-->
              <!--                  clearable-->
              <!--                  placeholder="请选择部门查询"-->
              <!--                  searchLabel="所在部门"-->
              <!--                >-->
              <!--                  <el-option key="1" label="已启用" value="1"></el-option>-->
              <!--                  <el-option key="2" label="已冻结" value="2"></el-option>-->
              <!--                  <el-option key="3" label="已注销" value="3"></el-option>-->
              <!--                </el-select>-->

              <el-input
                v-model="formData.loginname"
                clearable
                searchLabel="用户名"
                placeholder="请输入用户名模糊查询"
              ></el-input>
            </template>
            <!-- 表单高级搜索 -->
            <el-input
              v-model="formData.name"
              clearable
              searchLabel="姓名"
              placeholder="请输入姓名模糊查询"
              slot="searchItem1"
            ></el-input>
            <el-select
              v-model="formData.sex"
              clearable
              placeholder="请选择性别模糊查询"
              searchLabel="性别"
              slot="searchItem2"
            >
              <el-option key="1" label="男" value="1"></el-option>
              <el-option key="2" label="女" value="2"></el-option>
              <el-option key="0" label="未知" value="0"></el-option>
            </el-select>
            <el-select
              clearable
              ref="selectTree"
              v-model="formData.deptname"
              searchLabel="所在部门"
              placeholder="请选择所在部门查询"
              popper-class="popperTreeSelect"
              slot="searchItem3"
            >
              <el-option :value="valueUnit" :label="valueUnit">
                <el-tree
                  :props="defaultProps"
                  :load="loadNode"
                  node-key="id"
                  :default-expanded-keys="[1]"
                  @node-click="handleNodeClick"
                  lazy
                >
                </el-tree>
              </el-option>
            </el-select>
            <!--              <el-select-->
            <!--                v-model="formData.politicalOutlook"-->
            <!--                clearable-->
            <!--                placeholder="请选择部门查询"-->
            <!--                searchLabel="所在部门"-->
            <!--                slot="searchItem3"-->
            <!--                style="width:220px"-->
            <!--              >-->
            <!--                <el-option key="1" label="已启用" value="1"></el-option>-->
            <!--                <el-option key="2" label="已冻结" value="2"></el-option>-->
            <!--                <el-option key="3" label="已注销" value="3"></el-option>-->
            <!--              </el-select>-->
            <el-input
              v-model="formData.loginname"
              clearable
              searchLabel="用户名"
              placeholder="请输入用户名模糊查询"
              slot="searchItem4"
            ></el-input>
          </el-search>
          <!--普通搜索End-->
        </div>
        <div class="ccui-multifunctional-table-wrapper">
          <el-table
            ref="multipleTable"
            :data="tableData"
            :fit="true"
            :row-style="rowClass"
            :cell-style="cellStyle"
            border
            class="ccui-multifunctional-table"
            @select-all="handleCheckAllChange"
            @select="handleCheckChange"
            @selection-change="handleSelectionChange"
            max-height="20000"
          >
            <el-table-column
              type="selection"
              width="25"
              :selectable="filterCheck"
            />
            <el-table-column type="index" label="序号" fixed="left" width="45">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
                <!--{{ scope.$index + (pageNo - 1) * pageSize + 1 }}-->
              </template>
            </el-table-column>
            <el-table-column
              label="姓名"
              width="90"
              prop="name"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <template v-for="(table, index) in fixedTableThead">
              <el-table-column
                v-if="table.checked"
                :fixed="table.fixed"
                :key="index"
                :label="table.label"
                :width="table.width"
                :prop="table.prop"
                :show-overflow-tooltip="true"
              >
                <!--                <template #default="{row}">-->
                <!--                  {{-->
                <!--                    table.prop === "orgName"-->
                <!--                      ? row.orgName + "/" + row.deptname-->
                <!--                      : row[table.prop]-->
                <!--                  }}-->
                <!--                </template>-->
              </el-table-column>
            </template>

            <el-table-column label="操作" width="60" fixed="right">
              <template slot-scope="scope">
                <el-button
                  v-if="true"
                  size="mini"
                  type="text"
                  @click="handleDelete(scope.$index, scope.row)"
                  :disabled="ise && openId == scope.row.userId.split('@')[0]"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="ccui-table-footer" v-if="ifShowPage">
            <div v-show="isSelection" class="ccui-operation">
              <el-button size="mini" type="default" @click="handleDelSelected"
                >批量删除</el-button
              >
            </div>
            <div id="ccui-paging">
              <el-pagination
                :total="totalNum"
                :page-size="pageSize"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100, 200, 500]"
                prev-text="< 上一页"
                next-text="下一页 >"
                background
                layout="total, sizes, prev, pager, next, jumper"
                popper-class="ccui-paging-page-size-popper"
                @prev-click="handlePrev"
                @next-click="handleNext"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
              <el-button
                class="ccui-pagination-btn"
                size="mini"
                type="default"
                @click="handleSizeChange('none')"
                >确定
              </el-button>
            </div>
          </div>
        </div>

        <selectTree
          :isShow.sync="isShow"
          :requestSeachParams="requestSeachParams"
          :requestSeachFunction="requestSeachFunction"
          :requestTreeFunction="requestTreeFunction"
          :requestTreeParams="param"
          :setTreeICon="setTreeICon"
          :setSelectedIcon="setSelectedIcon"
          @selectedStaffSuccess="selectedStaffSuccess"
          :selectedData="selectedData"
          title="添加成员"
        >
          <div slot-scope="{ item }">
            <div :title="item.orderName" class="org-name">
              <i :class="setSeachIcon(item)" class="org-icon"></i>
              <span>{{ item.abbrName }}</span>
            </div>
            <p class="org-full-name" :title="item.orgFullName">
              {{ item.orgFullName }}
            </p>
          </div>
        </selectTree>
      </div>
    </div>
  </div>
</template>

<script>
import { searchList } from "../api/process";
import { getUnderOrg } from "../api/util.js";
import selectTree from "@/basa/components/selectTree";
import {
  removeUser,
  getUserList,
  saveUserList,
  addBatchAppUser
} from "../api/powerManage";
import getMenuaa from "../mixins/getMenu.js";
import { getdepartment } from "../api/item-list";
export default {
  name: "powerManageMemberMaintain",
  components: {
    selectTree
  },
  mixins: [getMenuaa],
  data() {
    return {
      ifShowPage: true,
      menu: [],
      ise: true,
      openId: "",
      appName: JSON.parse(sessionStorage.userDetal).agentName,
      requestTreeFunction: getUnderOrg,
      requestSeachFunction: searchList,
      selectedData: [],
      requestSeachParams: {
        flag: 2,
        branchName: "",
        orgID: ""
      },
      isShow: false,
      roleId: this.$route.query.roleId, // 当前角色
      param: {
        isPrincipal: 1,
        parentId: "", // 全局 其他【此组件是本级及以下】
        flag: "2", // 0 公司 1 部门 2 成员
        isCompany: "1" // 是否公司 0否 1是
      },
      // 表格最大高度
      tableMaxHeight: 0,
      // 表格数据
      tableData: [],
      selectRow: [],
      // 表格命名
      tableName: this.tableList.powerManagemMemberMaintain,
      // 表格数据
      tableThead: [],
      // 锁定表格
      fixedTableThead: [
        {
          label: "性别",
          prop: "sex",
          width: "50",
          checked: true,
          fixed: false
        },

        {
          label: "职务",
          prop: "empName",
          width: "150px",
          checked: true,
          fixed: false
        },
        {
          label: "单位/部门",
          prop: "comdept",
          width: "350px",
          checked: true,
          fixed: false
        },
        {
          label: "用户名",
          prop: "loginname",
          width: "200px",
          checked: true,
          fixed: false
        }
      ],

      demoKeys: [],
      // 弹框表格
      popoverShow: false,
      searchMoudle: {
        // 搜索模块数据
        isShow: false,
        searchData: {
          label: "姓名：",
          placeholder: "请输入姓名模糊查询",
          name: "userName"
        },
        inputSingle: "",
        input: "",
        value: "" // 简单搜索End
      },
      isSelection: false,
      isIndeterminate: false,
      checkAll: false,
      totalNum: 0,
      userName: "",
      pageSize: 10,
      pageNo: 1,
      formData: {
        loginname: "",
        name: "",
        sex: "",
        deptname: "",
        deptID: ""
      },
      valueUnit: "",
      defaultProps: {
        id: "partyId",
        children: "child",
        label: "orderName",
        isLeaf: "isLeaf"
      },
      //所在部门入参
      paramUnit: {
        parentId: "", // 全局 其他【此组件是本级及以下】
        flag: "0" // 0 公司 1 部门 2 成员
      }
    };
  },
  selectData(data) {
    this.selectRow = [];
    if (data.length > 0) {
      data.forEach((item, index) => {
        this.selectRow.push(this.tableData.indexOf(item));
      });
    }
  },
  watch: {
    popoverShow(value) {
      const that = this;
      if (value) {
        setTimeout(function() {
          document.body.addEventListener("click", that.closePopover);
        }, 0);
      } else {
        document.body.removeEventListener("click", that.closePopover);
      }
    }
  },
  created() {
    /** ****梁青竹 获取localStorage列表的条数Begin**********/
    let pageSizeObj = localStorage.getItem("amaMenberPageSize")
      ? JSON.parse(localStorage.getItem("amaMenberPageSize"))
      : null;
    this.pageSize =
      pageSizeObj && pageSizeObj[this.tableName]
        ? pageSizeObj[this.tableName]
        : this.pageSize; // 记住每页条数
    /** ****梁青竹 获取localStorage列表的条数End**********/
    // this.getRoleName();
    this.getList();
  },
  mounted() {
    this.ise = [100001, "100001"].includes(this.$route.query.roleId);
    this.openId = JSON.parse(localStorage.userInfo).openId;
    console.log(this.openId);
    console.log(this.$route.query.roleId, "this.$route.query.roleId");
    console.log(this.ise);
    this.roleId = this.$route.query.roleId;
    // 自动获取表格高度
    this.$nextTick(() => {
      this.computeTableHeight();
    });
    // 浏览器调整大小时，表格高度实时改变
    window.onresize = () => {
      this.computeTableHeight();
    };
  },
  activated() {
    this.ise = ["100001", 100001].includes(this.$route.query.roleId);
    this.openId = JSON.parse(localStorage.userInfo).openId;
    console.log(this.openId);
    console.log(this.$route.query.roleId, "this.$route.query.roleId");
    console.log(this.ise);
    this.roleId = this.$route.query.roleId;
    // 自动获取表格高度
    this.$nextTick(() => {
      this.computeTableHeight();
    });
    // 浏览器调整大小时，表格高度实时改变
    window.onresize = () => {
      this.computeTableHeight();
    };
    this.$store.dispatch("closeSidebarTemporary");
    this.ise = ["100001"].includes(this.$route.query.roleId);
    this.openId = JSON.parse(localStorage.userInfo).openId;
    this.roleId = this.$route.query.roleId;
  },
  methods: {
    filterCheck(row) {
      if (this.ise && row.openId === this.openId) {
        return false;
      } else {
        return true;
      }
    },
    setSeachIcon(i) {
      let arr = [
        "icon-ccui-organization",
        "icon-ccui-unit",
        "icon-ccui-man-hollow",
        "icon-ccui-woman-hollow"
      ];
      let keyClass = "";
      if (i.orgType === "2") {
        if (i.sex === "0") {
          keyClass = "";
        } else {
          keyClass = arr[Number(i.orgType) + Number(i.sex) - 1];
        }
      } else {
        keyClass = arr[i.orgType];
      }

      return keyClass;
    },
    setTreeICon(h, node, data, store) {
      //  console.log(node,data,store)
      if (data.orgType === "2") {
        if (data.sex === "2") {
          return <i class="icon-ccui-woman-hollow is-leaf-org"></i>;
        } else if (data.sex === "1") {
          return <i class="icon-ccui-man-hollow is-leaf-org"></i>;
        } else {
          return <i class="icon-ccui-man-hollow is-leaf-org"></i>;
        }
      }
      if (data.orgType === "0") {
        return <i class="icon-ccui-organization is-leaf-org"></i>;
      }
      if (data.orgType === "1") {
        return <i class="icon-ccui-unit is-leaf-org"></i>;
      }
    },
    setSelectedIcon({ sex }) {
      if (sex === "2") {
        return "icon-ccui-woman-hollow";
      } else {
        return "icon-ccui-man-hollow";
      }
    },
    initData() {
      this.pageNo = 1;
      this.userName = "";
      this.getList();
    },
    onSubmitSingle(obj) {
      this.pageNo = 1;
      this.userName = obj.userName;
      this.getList();
    },
    closePopover() {
      this.popoverShow = false;
    },
    handlePopoverShow(column, event) {
      if (column.label === "set") {
        this.popoverShow = !this.popoverShow;
      }
    },
    // 根据返回状态显示不同的文字颜色
    cellStyle({ row, column, rowIndex, columnIndex }) {},

    handleSelectionChange(data) {
      this.selectData = data;
    },
    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "rgba(255,232,195,1) " };
      }
    },
    handleGoEdit(index, row) {
      this.$router.push("/tmpl/demo/edit-demo/" + row.demoId);
    },
    handleDelete(index, row) {
      this.delList([{ openId: row.userId.split("@")[0], isShowLoading: true }]);
    },
    handleGoDetail(index, row) {
      this.$router.push(
        "/tmpl/demo/demo-detail/" + row.demoId + "/" + row.demoName
      );
    },
    /** *selectedStaff组件交互Begin***/
    handleAddMember() {
      this.requestSeachParams.orgID = this.$store.getters.userDetal.orgId + "";
      this.requestSeachParams.pageNo = 1;
      this.requestSeachParams.pageSize = 20;
      this.param.parentId = this.$store.getters.userDetal.partyRelaId;
      //this.chooseStaff.selectedData = []
      this.isShow = true;
    },
    selectedStaffSuccess(arr) {
      let arr2 = [];
      let arr3 = [];
      arr.forEach(n => {
        arr2.push({
          openId: n.userId.split("@")[0],
          autoCode: n.autoCode
        });
        arr3.push(n.userId);
      });
      addBatchAppUser({
        userIds: arr3
      }).then(res => {
        if (res.data.code == "0") {
          let obj = {
            userList: arr2,
            roleId: this.$route.query.roleId,
            isShowLoading: true
          };
          /* this.formdata.adminUserName = arr[0].name
    this.formdata.adminUserId = arr[0].userId */
          /* this.$refs['ruleForm'].validateField('adminUserId') */
          saveUserList(obj).then(res => {
            // let message = res.data.message || '添加成功'
            let message = this.tips.insertSuccessTip;
            this.$message({
              message: message,
              type: "success",
              duration: 3000,
              ccuiCustom: true,
              showClose: true,
              offset: document.body.clientHeight / 2 - 21
            });
            this.getList();
            this.getMenu();
          });
        }
      });
    },
    /** *selectedStaff组件交互End**/

    // 批量删除并刷新列表
    handleDelSelected() {
      console.log(this.idArrSelected);
      this.delList(this.idArrSelected);
    },
    handleExport() {
      console.log("导出", this.idArrSelected);
    },
    handlePrev() {
      console.log("上一页");
    },
    handleNext() {
      console.log("下一页");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // val !== 'none' && (this.pageSize = val)
      if (val !== "none") {
        /** ****梁青竹 存储localStorage列表的条数Begin**********/
        let pageSizeObj = localStorage.getItem("amaMenberPageSize")
          ? JSON.parse(localStorage.getItem("amaMenberPageSize"))
          : {};
        pageSizeObj[this.tableName] = val;
        localStorage.setItem("amaMenberPageSize", JSON.stringify(pageSizeObj));
        this.pageSize = val;
        /** ****梁青竹 存储localStorage列表的条数End**********/
      }
      this.getList();
    },
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.pageNo = val;
      this.getList();
    },
    // 数据请求
    getList(reqObj) {
      // 重置已选择的记录
      console.log(this.pageNo);
      let obj = {};
      obj = typeof reqObj == "object" ? reqObj : obj;
      obj.pageNo = this.pageNo;
      obj.pageSize = this.pageSize;
      obj.isShowPageLoading = true;
      obj.roleId = this.roleId;
      // const obj = {
      //   roleId: this.roleId,
      //   pageNo: this.pageNo,
      //   pageSize: this.pageSize,
      //   isShowPageLoading: true
      // };
      getUserList(obj).then(res => {
        console.log(res);
        if (res.data.code == "0") {
          this.tableData = res.data.data.rows.map(item => {
            // item.sex = item.sex === 1 ? "男" : "女"
            if (item.sex == 2) {
              item.sex = "女";
            } else if (item.sex == 1) {
              item.sex = "男";
            } else {
              item.sex = "";
            }
            return item;
          });
          if (this.tableData.length === 0) {
            this.ifShowPage = false;
          } else {
            this.ifShowPage = true;
          }
          this.totalNum = res.data.data.recordsTotal;
          this.pageNo = res.data.data.pageNo === 0 ? 1 : res.data.data.pageNo;
          console.log(res);
          this.isSelection = false;
          console.log(this.totalNum, this.pageNo);
        }
      });
    },
    delList(arr) {
      removeUser({
        userList: arr,
        roleId: this.roleId, // 当前角色id 需要改
        isShowLoading: true,
        loadingMessage: "删除中,请稍等..."
      }).then(res => {
        console.log(res);
        if (res.data.code === "0") {
          this.$message({
            message: this.tips.deleteSuccessTip,
            type: "success",
            duration: 3000,
            ccuiCustom: true,
            showClose: true,
            offset: document.body.clientHeight / 2 - 21
          });
          this.getMenu();
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            duration: 3000,
            ccuiCustom: true,
            showClose: true,
            offset: document.body.clientHeight / 2 - 21
          });
        }

        // console.log( this.pageNo)
        // console.log(Math.ceil(this.totalNum / this.pageSize))
        let totalPages = Math.ceil(this.totalNum / this.pageSize);
        let prevPage = this.pageNo - 1 === 0 ? 1 : this.pageNo - 1;
        let inItemLengs = this.totalNum - (this.pageNo - 1) * this.pageSize;
        if (totalPages === this.pageNo && arr.length === inItemLengs) {
          this.pageNo = prevPage;
        }

        this.getList();
        this.isSelection = false;
      });
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      const arr = [];
      console.log(val);
      for (let i = 0; i < val.length; i++) {
        arr.push({ openId: val[i].userId.split("@")[0] });
      }
      console.log(arr);
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (typeof val === "boolean") {
        if (val) {
          this.toggleSelection(this.tableData);
        } else {
          this.toggleSelection([]);
        }
      } else {
        this.checkAll = val.length !== 0;
      }
    },
    handleCheckChange(val) {
      console.log(val);
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push({ openId: val[i].userId.split("@")[0] });
      }
      this.idArrSelected = arr;
      console.log(this.idArrSelected);
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      console.log(val.length);
      if (val.length > 0 && val.length < 2) {
        this.isIndeterminate = true;
      } else if (val.length === 2) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    handleBack() {
      // 返回
      this.$router.push({ path: "/applicationSettings/roleManagement" });
    },
    // 计算表格高度方法
    computeTableHeight() {
      // 获取表格所占区域的总高度
      let appContainerHeight = document.documentElement.clientHeight - 160 - 40;
      // 获取搜索区域的高度
      let searchHeight = this.$refs.advancedSearchWrapper.clientHeight;
      // 获取面包屑高度
      let crumbsHeight = this.$refs.navigation.clientHeight;
      // 减去为表格所占高度，-70为距底边留白区域
      this.tableMaxHeight =
        appContainerHeight - searchHeight - crumbsHeight - 70 > 0
          ? appContainerHeight - searchHeight - crumbsHeight - 70
          : 0;
    },
    //高级搜索
    searchItem(data) {
      console.log(data);
      if (data.deptname && !data.deptID) {
        data.deptID = this.formData.deptID;
      } else if (!data.deptname) {
        delete data.deptID;
      }
      this.pageNo = 1;
      this.formData = data;
      this.getList(this.formData);
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        getdepartment({ flag: 1 }).then(res => {
          return resolve(res.data.data);
        });
      }
      if (node.level > 0) {
        getdepartment({ flag: 1, parentId: node.data.partyId }).then(res => {
          console.log(res.data.data);
          return resolve(res.data.data[0].child);
        });
      }
      // if (node.level === 0) {
      //   qryOmcOrgTree(this.param).then(res => {
      //     this.data = res.data.data
      //     return resolve(this.data)
      //   })
      // }
      // if (node.level > 1) {
      //   this.param.parentId = node.data.partyId
      //   qryOmcOrgTree(this.param).then(res => {
      //     return resolve(res.data.data[0].child)
      //   })
      //   return resolve([])
      // }
      // if (node.level === 1) {
      //   let that = this
      //   setTimeout(() => {
      //     let data = []
      //     data = that.data[0].child
      //     resolve(data)
      //   }, 500)
      // }
      // setTimeout(() => {
      //   const data = []
      //
      //   resolve(data)
      // }, 100)
    },
    handleNodeClick(data, node, b) {
      console.log(data, node);
      // if (node.isLeaf) {
      if (data.orgType) {
        this.formData.deptname = data.abbrName;
        this.formData.deptID = data.deptId;
        // this.formData.applicableUnitAutoCode = data.autoCode;
        this.$refs.selectTree.blur();
        this.$refs.selectTree1.blur();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/config/styles/variables.scss";

.app-container {
  background: none !important;
}
.fright {
  float: right;
}
.over-flow {
  overflow: auto;
}
.el-table-content {
  height: auto;
  background-color: $--color-white;
  padding: 20px;
  box-sizing: border-box;
}
.ccui-table-footer {
  margin-bottom: 20px;
}
/deep/ .el-table__fixed-right {
  height: auto;
}
.org-name {
  line-height: 18px;
}
.org-name span {
  font-size: 13px;
  color: #4a4a4a;
}
.org-icon {
  margin-right: 5px;
  color: #0089ef;
}
.org-full-name {
  line-height: 18px;
  margin-top: 5px;
  font-size: 13px;
  color: #999999;
  margin-left: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.requestSeachParamsorg-icon {
  color: #0089ef;
  margin-right: 5px;
}
</style>
